import React, { useEffect } from "react";
import {
  TrainingProgramLayout,
  StyledBorderedText,
  StyledLabel,
  StyledBorderedTextLong,
} from "./style";
import { StyledHorizontalDivider } from "../../../../../../components/common";
import { useAppDispatch, useAppSelector } from "../../../../../../store/config";
import {
  fetchUserTrainingProgramsStart,
  resetUserTrainingPrograms,
} from "../../../../../../store/features/user/training-programs/training-programs-slice";
import { useParams } from "react-router-dom";
import { Flex, notification, Pagination, Spin } from "antd";
import { useTranslation } from "react-i18next";
import {
  FullWidthFlex,
  NotFoundText,
} from "../../../../../../components/common/styles";
import { PAGE_SIZE } from "../../../../../../common/config";
import { ITrainingProgram } from "../../../../../../interfaces/store/training-program-interface";

export const TrainingProgram = (props: {
  type: "active" | "finished" | "unfinished";
}) => {
  const { type } = props;

  const [api, contextHolder] = notification.useNotification();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { id: userId } = useParams<{ id: string }>();

  const { trainingPrograms, error, loading, metadata } = useAppSelector(
    (state) => state.userTrainingPrograms
  );

  useEffect(() => {
    if (error) openNotification();
  }, [error]);

  useEffect(() => {
    fetchTrainingPrograms(0, 1);
  }, [type, userId, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(resetUserTrainingPrograms());
    };
  }, []);

  const onPaginationChange = (page: number) => {
    fetchTrainingPrograms(PAGE_SIZE * (page - 1), page);
  };

  const fetchTrainingPrograms = (skip: number, page: number) => {
    userId &&
      dispatch(
        fetchUserTrainingProgramsStart({
          type,
          userId,
          skip,
          limit: PAGE_SIZE,
          page,
        })
      );
  };

  const openNotification = () => {
    api["error"]({
      message: t("Something went wrong, please try again"),
      placement: "bottomLeft",
    });
  };

  const isProgramWithTrainingProgram = (
    program: (typeof trainingPrograms)[number]
  ): program is {
    _id: string;
    completedAt: string;
    trainingProgram: ITrainingProgram;
  } => {
    return !!(program as { trainingProgram: ITrainingProgram }).trainingProgram;
  };

  return (
    <>
      {contextHolder}
      <TrainingProgramLayout>
        <Spin spinning={loading}>
          <Flex justify="center" vertical>
            {(!trainingPrograms || trainingPrograms.length === 0) &&
            !loading ? (
              <NotFoundText>{t("No training programs found")} </NotFoundText>
            ) : (
              <>
                {trainingPrograms?.map((program, index) => (
                  <Flex vertical key={index} style={{ width: "75%" }}>
                    <FullWidthFlex gap={30}>
                      <Flex gap={5} vertical style={{ width: "60%" }}>
                        <StyledLabel>
                          {type === "active"
                            ? t("Assigned Training Program")
                            : t("Program Name")}
                        </StyledLabel>
                        <StyledBorderedTextLong>
                          {program
                            ? isProgramWithTrainingProgram(program)
                              ? program.trainingProgram.name
                              : program.name
                            : t("Deleted Program")}
                        </StyledBorderedTextLong>
                      </Flex>

                      {/* <Flex vertical style={{ width: "20%" }}> */}
                      {/* <StyledLabel> {t("Week in the program")} </StyledLabel> */}
                      {/* <StyledBorderedText> */}
                      {/* {2}/{3} */}
                      {/* </StyledBorderedText> */}
                      {/* </Flex> */}

                      {type === "finished" && program && (
                        <Flex vertical style={{ width: "20%" }}>
                          <StyledLabel>{t("End Date")}</StyledLabel>
                          <StyledBorderedText>
                            {isProgramWithTrainingProgram(program) &&
                            program.completedAt
                              ? new Date(program.completedAt)
                                  .toLocaleDateString("en-GB")
                                  .replace(/\//g, ".")
                              : ""}
                          </StyledBorderedText>
                        </Flex>
                      )}
                    </FullWidthFlex>
                    {index < trainingPrograms.length - 1 && (
                      <StyledHorizontalDivider />
                    )}
                  </Flex>
                ))}
              </>
            )}
          </Flex>
          {type !== "active" && (
            <Pagination
              current={metadata?.page}
              pageSize={PAGE_SIZE}
              total={metadata?.total}
              align="center"
              hideOnSinglePage
              onChange={onPaginationChange}
              showSizeChanger={false}
              style={{ direction: "ltr", marginTop: "60px" }}
            />
          )}
        </Spin>
      </TrainingProgramLayout>
    </>
  );
};
